export const NOTIFICATION_SESSION_STORAGE_KEY =
  "Asos.ProductPage.BackInStockVariantIds";
